import type { TransformerExtended } from "@/Common/Models/Domain/Transformer";

import DefaultTransformerGenerator from "@/Common/Transformers/FunctionalBase";

import type { PatientWithAppointmentApi } from "../Models/Api/Schedule";
import type { PatientWithAppointment } from "../Models/Domain/Schedule";

import UserTransformer from "./User/User";

const PatientTransformer: TransformerExtended<PatientWithAppointment, PatientWithAppointmentApi> = {
  ...DefaultTransformerGenerator<PatientWithAppointment, PatientWithAppointmentApi>(),

  toDomain(input: PatientWithAppointmentApi) {
    return {
      ...UserTransformer.toDomain(input),
      numAppointments: input.num_appointments,
      planTitle: input.plan_title,
    };
  },
};

export type PatientTransformerType = TransformerExtended<PatientWithAppointment, PatientWithAppointmentApi>;

export default PatientTransformer;
